export type SelectionFlags = {
  /** Every relationship the object has is selected, not just every one on this page. */
  isAllSelected: boolean;
  isPageSelected: boolean;
  isIndeterminate: boolean;
};

/**
 * The three states the header checkbox and the count copy read from.
 *
 * Selection never leaves the current page — paging clears it — so the selected
 * count can only reach the total when one page holds every relationship.
 * `total` is `-1` until the first page loads, which is why "all selected" tests
 * for a positive total instead of comparing counts alone.
 */
export function selectionFlags(selectedCount: number, pageCount: number, total: number): SelectionFlags {
  const isPageSelected = selectedCount > 0 && selectedCount === pageCount;

  return {
    isAllSelected: total > 0 && selectedCount === total,
    isPageSelected,
    isIndeterminate: selectedCount > 0 && !isPageSelected,
  };
}
